import { parseISO } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, DisplayL, DisplayS } from '@sorare/core/src/atoms/typography';
import { Countdown } from '@sorare/core/src/components/Countdown';
import Dialog from '@sorare/core/src/components/dialog';
import { useOneTimeDialogContext } from '@sorare/core/src/contexts/oneTimeDialog';
import { OneTimeDialog } from '@sorare/core/src/contexts/oneTimeDialog/Provider';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { glossary } from '@sorare/core/src/lib/glossary';

import { NeonChristmasBackground } from '../NeonChristmasBackground';
import cardUrl from './assets/card.png';
import creditUrl from './assets/credit.png';
import essenceUrl from './assets/essence.png';

const startDate = parseISO('2024-12-01T11:00:00+01:00');

const Content = styled(Vertical).attrs({ center: true })`
  padding: var(--double-unit);
  text-align: center;
`;

const Illustration = styled.figure`
  margin: 0;
  position: relative;
  height: 280px;
  width: 100%;
  > * {
    position: absolute;
    left: 50%;
    bottom: 40px;
    scale: 0.5;
    transform-origin: center bottom;
    filter: drop-shadow(0 0 48px var(--c-nl-900));
    &:nth-child(1) {
      left: calc(50% - 80px);
      translate: -45% -40px;
    }
    &:nth-child(2) {
      bottom: 80px;
    }
    &:nth-child(3) {
      translate: -50% 0;
    }
  }
`;

export const Teaser = () => {
  const {
    flags: { useNeonChristmas = false },
  } = useFeatureFlags();
  const { sawDialog } = useOneTimeDialogContext();
  if (!useNeonChristmas) {
    return null;
  }

  return (
    <OneTimeDialog
      dialogId={LIFECYCLE.sawNeonChristmasDialog}
      show={!sawDialog(LIFECYCLE.sawNeonChristmasDialog)}
    >
      {({ onClose, open }) => (
        <Dialog
          maxWidth="xs"
          fullWidth
          open={open}
          hideHeader
          style={{
            border: '1px solid var(--c-nd-100)',
            borderRadius: 'var(--unit)',
            overflow: 'clip',
          }}
        >
          <NeonChristmasBackground>
            <Content>
              <Illustration>
                <img src={essenceUrl} alt="" />
                <img src={creditUrl} alt="" />
                <img src={cardUrl} alt="" />
              </Illustration>
              <DisplayL>
                <FormattedMessage
                  id="neonChristmas.teaser.title"
                  defaultMessage="New surprises everyday"
                />
              </DisplayL>
              <BodyM>
                <FormattedMessage
                  id="neonChristmas.teaser.description"
                  defaultMessage="🎅 Christmas is coming in the market in:"
                />
              </BodyM>
              <DisplayS>
                <Countdown
                  date={startDate}
                  greyOutZeros
                  gap={2}
                  Label={DisplayS}
                />
              </DisplayS>
              <Button
                size="medium"
                onClick={onClose}
                color="secondary"
                fullWidth
              >
                <FormattedMessage {...glossary.continue} />
              </Button>
            </Content>
          </NeonChristmasBackground>
        </Dialog>
      )}
    </OneTimeDialog>
  );
};
